import { formatTimestampHuman } from "../date-utils";
export const companyDtoFields = [{
        name: "name",
        title: "Nome",
        render: (record) => record.company.name
        // }, {
        //   name: "countryDescription",
        //   title: "Nazione"
    }, {
        name: "companyTypeDescription",
        title: "Tipologia",
        render: (record) => record.company.companyType
        // }, {
        //   name: "companySizeDescription",
        //   title: "Dimensione"
        // }, {
        //   name: "industryDescription",
        //   title: "Industria"
        // }, {
        //   name: "sourceDescription",
        //   title: "Sorgente"
    }, {
        name: "vatNumber",
        title: "Partita IVA",
        render: (record) => record.company.vatNumber
    }, {
        name: "fiscalCode",
        title: "CodiceFiscale",
        render: (record) => record.company.fiscalCode
    }, {
        name: "city",
        title: "Comune",
        render: (record) => record.company.city
    }, {
        name: "province",
        title: "Provincia",
        render: (record) => record.company.province
    }, {
        name: "responsibleUser",
        titleClass: "has-text-centered",
        dataClass: "has-text-centered",
        title: "Responsabile"
    }, {
        name: "updatedBy",
        titleClass: "has-text-centered",
        dataClass: "has-text-centered",
        title: "Ultima Modifica"
    }, {
        name: "updatedOn",
        title: "Data Modifica",
        titleClass: "has-text-centered",
        dataClass: "has-text-centered",
        render: (record) => formatTimestampHuman(record.company.updatedOn)
    }];
